import { useTopSellingProductsQuery } from '@/generated/graphql-react-query';

export const useTopSellingProducts = ({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}) => {
  const { data, isLoading } = useTopSellingProductsQuery({
    input: {
      filter: {
        startedAt: startDate,
        endAt: endDate,
      },
    },
  });

  return {
    data: data?.topSellingProducts || [],
    isLoading,
  };
};
